/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Form_Invoice_Buyer_Email_ReminderInputs */

const vi_order_form_invoice_buyer_email_reminder = /** @type {(inputs: Order_Form_Invoice_Buyer_Email_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email chưa đúng định dạng. Kiểm tra lại, ví dụ: ketoan@congty.vn.`)
};

/**

* @param {Order_Form_Invoice_Buyer_Email_ReminderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_form_invoice_buyer_email_reminder = /** @type {((inputs?: Order_Form_Invoice_Buyer_Email_ReminderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Form_Invoice_Buyer_Email_ReminderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_form_invoice_buyer_email_reminder(inputs)
});